import React from 'react';
import { Card, ErrorWrapper } from '../../components';
import { useErrorChecker } from '../../hooks';
import { RemoveButton } from '../RemoveButton';
export const CardAccordeon = ({ name, spec, input, meta, children, }) => {
    var _a;
    const [open, setOpen] = React.useState(Boolean((_a = spec.viewSpec) === null || _a === void 0 ? void 0 : _a.layoutOpen));
    const onToggle = React.useCallback(() => setOpen((f) => !f), [setOpen]);
    const onDrop = React.useCallback(() => {
        setOpen(false);
        input.onDrop();
    }, [input.onDrop, setOpen]);
    const removeButton = React.useMemo(() => {
        if (spec.required || !input.value) {
            return null;
        }
        return React.createElement(RemoveButton, { onDrop: onDrop, name: name });
    }, [spec.required, input.value, onDrop, name]);
    useErrorChecker({ name, meta, open, setOpen });
    return (React.createElement(Card, { name: name, title: spec.viewSpec.layoutTitle, description: spec.viewSpec.layoutDescription, actions: removeButton, open: open, onToggle: onToggle },
        React.createElement(ErrorWrapper, { name: name, meta: meta, withoutChildErrorStyles: true }, children)));
};
